import React from 'react';

const mediumFilterButton = (props) => {

  if (props.status === true && props.amountSelectedLines === 0) {
    return (
      <button type="button" className="btn btn-filter btn-medium-filter-selected-true" onClick={props.onClick}>
        <i className="material-icons" style={{fontSize: "inherit", verticalAlign: "inherit", marginRight: "5px"}}>check_box</i>{props.title}
      </button>
  )} else if (props.status === true && props.amountSelectedLines > 0) {
    return (
      <button type="button" className="btn btn-filter btn-medium-filter-selected-true btn-medium-filter-selected-locked">
        <i className="material-icons shaker" style={{fontSize: "inherit", verticalAlign: "inherit", marginRight: "5px"}}>lock</i>{props.title}<span className="badge badge-light ml-1">{props.amountSelectedLines}</span>
      </button>
  )} else {
    return (
      <button type="button" className="btn btn-filter btn-medium-filter-selected-false" onClick={props.onClick}>
        <i className="material-icons" style={{fontSize: "inherit", verticalAlign: "inherit", marginRight: "5px"}}>check_box_outline_blank</i>{props.title}
      </button>
  )}

};

export default mediumFilterButton;



// WEBPACK FOOTER //
// ./src/components/Shared/MediumFilterButton.js